export default __webpack_public_path__ + "static/media/hexagon.d3f2530d.svg";